import { render, staticRenderFns } from "./EditThreadColorsForm.vue?vue&type=template&id=00465d46&"
import script from "./EditThreadColorsForm.vue?vue&type=script&lang=js&"
export * from "./EditThreadColorsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports